<template>
    <div class="blocAddRef">
        <div v-if="!isRefAvailable" id="stock-empty-alert" class="alert alert-danger">{{ notAvailableMessage }}</div>
        <form v-on:submit.prevent="search" class="form-inline">
            <div class="row no-gutters">
                <div class="col-lg-3 text-center text-lg-right">
                    <h4>Ajouter un produit à partir de sa référence</h4>
                </div>
                <div class="col-lg-2">
                    <input type="text" class="form-control" id="ref" placeholder="Ex. YMR" v-model="reference">
                </div>
                <div class="col-lg-4">
                    <ponroy-cart-quantity buttonType="button" v-model="quantity"></ponroy-cart-quantity>
                </div>
                <div class="col-lg-3 text-center text-lg-left">
                    <button @click="search()" type="submit" class="btn btn-primary" :class="{ 'btn-default-2': !isCatalogOrder }">
                        Ajouter au panier
                    </button>
                </div>
            </div>
        </form>
        <div v-if="error" class="error">
            Merci de renseigner une référence valide
        </div>
    </div>
</template>

<script>

    import {mapState, mapActions, mapGetters} from 'vuex';

    import store from '../store';
    import CartQuantity from './CartQuantity.vue';
    import request from '../store/utils/request';

    const CartSearch = {
        name: 'ponroy-cart-search',
        store,
        components: {
          CartQuantity,
        },
        props: {
            repository: {
                type: String,
                required: true,
            },
            isCatalogOrder: {
                type: Boolean,
                required: true,
            }
        },
        data() {
            return {
                orderable: {
                    repository: this.repository,
                    id : null,
                },
                quantity: 1,
                reference: null,
                error: false,
            }
        },
        computed: {
            ...mapGetters('cart', [
                'notAvailableMessage',
                'isRefAvailable',
            ]),
        },
        methods: {
            ...mapActions('cart', [
                'addToCart',
                'checkStockAvailable',
            ]),
            async search(event) {
                if (this.reference) {
                    const {quantity} = this;
                    this.checkStockAvailable({
                        orderable: {
                            repository: this.repository,
                            id: this.reference.toUpperCase()
                        },
                        'quantity': quantity
                    });

                    this.reference = null;
                }
            },
        }
    };

    export default CartSearch;
</script>



// WEBPACK FOOTER //
// src/SiteBundle/Resources/assets/components/CartSearch.vue